// Select enhancement script
document.addEventListener('DOMContentLoaded', function() {
    // Target all selects except those with specific classes
    const selects = document.querySelectorAll('select:not(.shop-sorting):not(.shop-per-page):not(.blog-filters__sort-select):not(.ui-datepicker-month):not(.ui-datepicker-year)');
    
    if (selects.length) {
        // Process each select element
        selects.forEach(select => {
            // Create a wrapper if it doesn't exist already
            if (!select.parentElement.classList.contains('select-wrapper')) {
                const wrapper = document.createElement('div');
                wrapper.className = 'select-wrapper';
                select.parentNode.insertBefore(wrapper, select);
                wrapper.appendChild(select);
            }
            
            // Track select open state
            let isOpen = false;
            
            // Handle open state
            select.addEventListener('focus', () => {
                isOpen = true;
            });
            
            // Handle closing on selection
            select.addEventListener('change', function() {
                setTimeout(() => {
                    this.blur();
                    isOpen = false;
                }, 50);
            });
            
            // Handle blur event
            select.addEventListener('blur', () => {
                isOpen = false;
            });
        });
        
        // Global click handler to close any open selects when clicking elsewhere
        document.addEventListener('click', function(event) {
            const clickedSelect = event.target.closest('select');
            
            if (!clickedSelect) {
                selects.forEach(select => {
                    select.blur();
                });
            }
        });
    }
    
    // Apply positioning for select arrows if needed
    const selectContainers = document.querySelectorAll('.select-wrapper');
    selectContainers.forEach(container => {
        const select = container.querySelector('select');
        if (select) {
            // This ensures proper vertical alignment of the arrow
            const observer = new ResizeObserver(() => {
                const selectRect = select.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();
                const selectMiddle = selectRect.height / 2;
                container.style.setProperty('--select-middle', `${selectMiddle}px`);
            });
            
            observer.observe(select);
        }
    });
});


// Enhanced select handling for shop filters
document.addEventListener('DOMContentLoaded', function() {
    // Handle the special shop sorting and per page selects separately
    const shopSelects = document.querySelectorAll('.shop-sorting, .shop-per-page');
    
    shopSelects.forEach(select => {
        const parent = select.parentElement;
        
        // Track focus state
        select.addEventListener('focus', () => {
            parent.classList.add('select-open');
        });
        
        // Handle blur events to reset the arrow rotation
        select.addEventListener('blur', () => {
            parent.classList.remove('select-open');
        });
        
        // Handle change events - close dropdown after selection
        select.addEventListener('change', function() {
            // Adjust width based on selected option text for better UX
            const selectedOption = this.options[this.selectedIndex];
            const tempSpan = document.createElement('span');
            tempSpan.style.visibility = 'hidden';
            tempSpan.style.position = 'absolute';
            tempSpan.style.fontSize = window.getComputedStyle(this).fontSize;
            tempSpan.style.fontFamily = window.getComputedStyle(this).fontFamily;
            tempSpan.style.textTransform = 'uppercase';
            tempSpan.style.fontWeight = window.getComputedStyle(this).fontWeight;
            tempSpan.style.letterSpacing = window.getComputedStyle(this).letterSpacing;
            tempSpan.innerText = selectedOption.text;
            document.body.appendChild(tempSpan);
            
            // Set width with some padding for the arrow
            const width = tempSpan.offsetWidth + 40;
            this.style.width = `${width}px`;
            document.body.removeChild(tempSpan);
            
            // Blur after selection to close dropdown
            setTimeout(() => {
                this.blur();
            }, 50);
        });
        
        // Initialize width based on default selection
        if (select.options.length > 0) {
            const selectedOption = select.options[select.selectedIndex];
            const tempSpan = document.createElement('span');
            tempSpan.style.visibility = 'hidden';
            tempSpan.style.position = 'absolute';
            tempSpan.style.fontSize = window.getComputedStyle(select).fontSize;
            tempSpan.style.fontFamily = window.getComputedStyle(select).fontFamily;
            tempSpan.style.textTransform = 'uppercase';
            tempSpan.style.fontWeight = window.getComputedStyle(select).fontWeight;
            tempSpan.style.letterSpacing = window.getComputedStyle(select).letterSpacing;
            tempSpan.innerText = selectedOption.text;
            document.body.appendChild(tempSpan);
            
            // Set width with some padding for the arrow
            const width = tempSpan.offsetWidth + 40;
            select.style.width = `${width}px`;
            document.body.removeChild(tempSpan);
        }
    });
    
    // Click outside to close any open shop selects
    document.addEventListener('click', function(event) {
        if (!event.target.closest('.filter-sorting') && !event.target.closest('.filter-per-page')) {
            shopSelects.forEach(select => {
                select.blur();
            });
        }
    });
});